  import React from 'react'
  import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
  import { Toaster, ToastBar, toast } from 'react-hot-toast'
  import { DndProvider } from 'react-dnd'
  import { HTML5Backend } from 'react-dnd-html5-backend'

  import LoginPage from './pages/LoginPage'
  import AdminDashboard from './pages/AdminDashboard'
  import SurveyManager from './pages/SurveyManager'
  import QuestionBank from './pages/QuestionBank'
  import ResearcherManager from './pages/ResearcherManager'
  import AdminManager from './pages/AdminManager'
  import ClientManager from './pages/ClientManager'
  import Analytics from './pages/Analytics'
  import ResearcherDashboard from './pages/ResearcherDashboard'
  import ResearcherHistory from './pages/ResearcherHistory'
  import ClientResultsPortal from './pages/ClientResultsPortal'
  import PublicSurveyResponder from './pages/PublicSurveyResponder'
  import AudioPlayerPage from './pages/AudioPlayerPage'
  import Layout from './components/Layout'
  import { readSession } from './lib/appSession'
  import type { UserProfile } from './lib/appSession'

  const LoginRedirect: React.FC = () => {
    const session = readSession()

    if (session) {
      return <Navigate to={session.profile === 'admin' ? '/admin' : '/researcher'} replace />
    }

    return <LoginPage />
  }

  const ProtectedLayout: React.FC<{ userType: UserProfile }> = ({ userType }) => {
    const location = useLocation()
    const session = readSession()

    if (!session || session.profile !== userType) {
      return <Navigate to="/login" replace state={{ from: location.pathname }} />
    }

    return <Layout userType={userType} />
  }

  function App() {
    return (
      <DndProvider backend={HTML5Backend}>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              background: '#363636',
              color: '#fff',
              cursor: 'pointer',
            },
            success: {
              style: {
                background: '#10b981',
              },
            },
            error: {
              duration: 3500,
              style: {
                background: '#ef4444',
              },
            },
          }}
        >
          {(t) => (
            <div
              onClick={() => toast.dismiss(t.id)}
              className="cursor-pointer transition-transform hover:scale-[1.02]"
              title="Clique para fechar"
            >
              <ToastBar toast={t} />
            </div>
          )}
        </Toaster>

        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/" element={<LoginRedirect />} />
              <Route path="/login" element={<LoginRedirect />} />
              <Route path="/client-results/:token" element={<ClientResultsPortal />} />
              <Route path="/responder-pesquisa/:token" element={<PublicSurveyResponder />} />
              <Route path="/ouvir-audio" element={<AudioPlayerPage />} />
              <Route path="/audio-player" element={<AudioPlayerPage />} />

              <Route path="/admin" element={<ProtectedLayout userType="admin" />}>
                <Route index element={<AdminDashboard />} />
                <Route path="surveys" element={<SurveyManager />} />
                <Route path="questions" element={<QuestionBank />} />
                <Route path="clients" element={<ClientManager />} />
                <Route path="researchers" element={<ResearcherManager />} />
                <Route path="admins" element={<AdminManager />} />
                <Route path="analytics" element={<Analytics />} />
              </Route>

              <Route path="/researcher" element={<ProtectedLayout userType="researcher" />}>
                <Route index element={<ResearcherDashboard />} />
                <Route path="history" element={<ResearcherHistory />} />
              </Route>

              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </DndProvider>
    )
  }

  export default App
